import React from 'react';
import { Box } from '@mui/material';
import { PermissionsGate } from '@components';
import { NoAccess, Loader } from 'components/common/ui';
import styles from './basicLayout.style';

const BasicLayout = ({ children, entity, isLoading }) => {
  return (
    <PermissionsGate entity={entity} RenderError={NoAccess}>
      {isLoading ? (
        <Loader />
      ) : (
        <Box sx={styles.wrapper}>
          <Box sx={styles.innerWrapper}>
            <Box sx={styles.content}>{children}</Box>
          </Box>
        </Box>
      )}
    </PermissionsGate>
  );
};

export default BasicLayout;
